/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { Locale } from '../locale/Locale';
import { LocaleKeys } from '../locale/LocaleKeys';
import { AppError } from './AppError';

export class PreSignInError extends AppError {
    TAG: string = 'PreSignInError';

    protected title: string = Locale.getString(LocaleKeys.TEMPORARY_SERVICE_CONNECTION_ISSUE_TITLE);

    protected description: string = Locale.getString(
        LocaleKeys.TEMPORARY_SERVICE_CONNECTION_ISSUE_DESCRIPTION,
    );

    protected type: string = '';

    constructor(message: string, code: string) {
        super(code, message);
    }

    public getDescription() {
        return this.description;
    }

    public getTitle() {
        return this.title;
    }

    public getType() {
        return this.type;
    }
}
